<div fxLayout fxLayoutAlign="start center" fxLayoutGap="6px" class="detail-subheader">
  <strong fxFlex>{{ label }}</strong>

  <sbnb-button *ngIf="!editMode" size="mini" label="Edit" type="text" (click)="editMode = true"></sbnb-button>

  <sbnb-property-update-status
    [edited]="edited"
    [moveIcons]="editMode"
    [hasAirbnbListing]="hasAirbnbListing"></sbnb-property-update-status>
</div>
<span *ngIf="!editMode" class="night text__small clamp">
  {{ value || placeholder }}
</span>

<ng-container *ngIf="editMode">
  <textarea #summaryTextarea [value]="value" (keyup)="inputEdited = true"></textarea>

  <div fxLayoutAlign="end center" fxLayoutGap="8px">
    <sbnb-button
      [label]="edited || !hasAirbnbListing || !inputEdited ? 'Cancel' : 'Cancel & Keep Linked'"
      type="secondary"
      size="mini"
      (clicked)="editMode = false; inputEdited = false"></sbnb-button>
    <sbnb-button
      [label]="edited || !hasAirbnbListing || !inputEdited ? 'Save' : 'Save & Unlink'"
      size="mini"
      (clicked)="
        editMode = false; inputEdited = false; value = summaryTextarea.value; updated.emit(value)
      "></sbnb-button>
  </div>
</ng-container>
